import {CommonModule} from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    computed,
    effect,
    inject, OnInit,
    signal,
    ViewChild
} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

/* If you have a shared header module, keep this import/path as-is */
import {
    Employee,
    Mark, MarkKind,
    YearCalendarComponent
} from "../../../shared/components/calendar/year-calendar-component/year-calendar.component";
import {ListHeaderComponent} from "../../../shared/components/item-list/list-header";
import {TranslocoPipe} from "@ngneat/transloco";
import {MatProgressBar} from "@angular/material/progress-bar";
import {FuseMasonryComponent} from "../../../../@fuse/components/masonry";
import {MatButton} from "@angular/material/button";
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from "@angular/material/sidenav";
import {MatIcon} from "@angular/material/icon";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {Absence, AbsencesLeaveService} from "./absences-leave.service";
import {firstValueFrom} from "rxjs";
import {UsersService} from "../../admin/users/users.service";
import {
    MiniCalCellClickEvent
} from "../../../shared/components/calendar/mini-calendar-component/mini-calendar.component";
import {HolidaysService} from "../holidays-management/holidays.service";
import {Holiday} from "../holidays-management/holidays.types";
import {AbsenceRecapTableComponent} from "./absence-recap-table/absence-recap-table.component";
import {Utils} from "../../../shared/utils"; // <app-list-header>

@Component({
    selector: 'app-absences-leave-management',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ListHeaderComponent,     // <app-list-header>
        YearCalendarComponent,
        YearCalendarComponent,
        TranslocoPipe,
        MatProgressBar,
        FuseMasonryComponent,
        MatButton,
        MatDrawer,
        MatDrawerContainer,
        MatDrawerContent,
        MatIcon,
        RouterOutlet,
        AbsenceRecapTableComponent,
        // <app-year-calendar>
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div
            class="sm:absolute sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">

            <!-- LOADER -->
            <!--            <div-->
            <!--                *ngIf="!matDrawer.opened && isLoading()"-->
            <!--                class="sticky z-10 inset-x-0 top-0 w-full">-->
            <!--                <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>-->
            <!--            </div>-->
            <!-- / LOADER -->

            <mat-drawer-container
                class="w-full h-full bg-gray-50"
                (backdropClick)="onBackdropClicked()">

                <!-- Drawer -->
                <mat-drawer
                    class="w-full h-full md:w-160 dark:bg-gray-900"
                    [mode]="drawerMode"
                    [opened]="false"
                    [position]="'end'"
                    [disableClose]="drawerDisableClose"
                    #matDrawer>
                    <router-outlet class="h-full"></router-outlet>
                </mat-drawer>

                <mat-drawer-content class="flex flex-col">

                    <!-- Main -->
                    <div class="flex-auto">

                        <!-- Header -->
                        <!--    [searchPlaceholder]="('SEARCH' | transloco)"-->
                        <!--    [searchInputControl]="searchInputControl"-->
                        <div class="bg-card">
                            <app-list-header
                                [isLoading]="isLoading()"
                                [entityTitle]="('NAVIGATION.LEAVE_MANAGEMENT' | transloco)"
                                [addButtonLabel]="''"
                                (addEntityClick)="onAddClicked()">
                            </app-list-header>
                        </div>

                        <div class="relative mx-auto flex flex-col w-full overflow-auto p-4 gap-4">

                            <!-- Top toolbar (year + quick actions) -->
                            <!--      <div class="flex items-center justify-between">-->
                            <!--        <div class="flex items-center gap-2">-->
                            <!--          <button class="px-2 py-1 rounded border hover:bg-black/5" (click)="prevYear()">-->
                            <!--            &laquo; {{ year() - 1 }}-->
                            <!--          </button>-->
                            <!--          <div class="text-lg font-semibold tabular-nums">{{ year() }}</div>-->
                            <!--          <button class="px-2 py-1 rounded border hover:bg-black/5" (click)="nextYear()">-->
                            <!--            {{ year() + 1 }} &raquo;-->
                            <!--          </button>-->
                            <!--        </div>-->

                            <!--        &lt;!&ndash; Optional legend &ndash;&gt;-->
                            <!--        <div class="hidden md:flex items-center gap-3 text-sm">-->
                            <!--          <span class="inline-flex items-center gap-1">-->
                            <!--            <span class="w-3 h-3 inline-block rounded bg-blue-200"></span> Activity-->
                            <!--          </span>-->
                            <!--          <span class="inline-flex items-center gap-1">-->
                            <!--            <span class="w-3 h-3 inline-block rounded bg-yellow-300"></span> Holiday-->
                            <!--          </span>-->
                            <!--          <span class="inline-flex items-center gap-1">-->
                            <!--            <span class="w-3 h-3 inline-block rounded bg-red-300"></span> Absence-->
                            <!--          </span>-->
                            <!--        </div>-->
                            <!--      </div>-->

                            <!-- Recap table -->
<!--                            <app-absence-recap-table-->
<!--                                [isLoading]="isLoading()"-->
<!--                                [year]="year()"-->
<!--                                [cutoff_date]="recap?.[0]?.cutoff_date"-->
<!--                                [recapData]="recap">-->
<!--                            </app-absence-recap-table>-->

                            <!-- Year grid -->
                            <app-year-calendar
                                [loading]="isLoading()"
                                [yearInput]="year()"
                                [employeesInput]="employees()"
                                [marksInput]="marks()"
                                [headerClassesByMonth]="headerByMonth"
                                [weekendRowClassesByMonth]="weekendByMonth"
                                (cellClick)="onCell($event)"
                                (dayClick)="onDay($event)"
                                (yearChange)="onYearChanged($event)"
                                (monthChange)="onMonth($event)">
                            </app-year-calendar>

                        </div>

                    </div>

                </mat-drawer-content>

            </mat-drawer-container>

        </div>
    `,
})
export class YearlyPlansPageComponent implements OnInit {
    _usersService = inject(UsersService);
    _absencesLeaveService = inject(AbsencesLeaveService);
    _holidaysService = inject(HolidaysService);
    _router = inject(Router);
    _utils = inject(Utils);
    _activatedRoute = inject(ActivatedRoute);
    _changeDetectorRef = inject(ChangeDetectorRef);

    @ViewChild('matDrawer', {static: true}) matDrawer: MatDrawer;
    drawerMode: 'side' | 'over';
    drawerDisableClose: boolean = true;
    edittingItem: boolean = false;

    /** Loading indicator bound to the header. Toggle while (re)fetching. */
    readonly isLoading = signal(false);

    /** Search control bound to the header’s search input. */
    readonly searchInputControl = new FormControl<string>('', {nonNullable: true});

    /** Active year (signals make binding trivial). */
    private readonly _year = signal<number>(new Date().getFullYear());
    readonly year = this._year.asReadonly();

    /** Employees shown as columns inside each mini calendar. */
    private readonly _employees = signal<Employee[]>([]);
    readonly employees = this._employees.asReadonly();

    /** Year marks (month splitting is handled inside <app-year-calendar>). */
    private readonly _marks = signal<Mark[]>([]);
    readonly marks = this._marks.asReadonly();

    /** Recap data for the year (optional). */
    recap: any[] = [];

    /** Optional per-month color overrides (12 entries each). */
    readonly headerByMonth = [
        'bg-red-50', 'bg-orange-50', 'bg-amber-50', 'bg-yellow-50', 'bg-lime-50', 'bg-green-50',
        'bg-emerald-50', 'bg-teal-50', 'bg-cyan-50', 'bg-sky-50', 'bg-indigo-50', 'bg-violet-50'
    ];
    readonly weekendByMonth = [
        'bg-red-100', 'bg-orange-100', 'bg-amber-100', 'bg-yellow-100', 'bg-lime-100', 'bg-green-100',
        'bg-emerald-100', 'bg-teal-100', 'bg-cyan-100', 'bg-sky-100', 'bg-indigo-100', 'bg-violet-100'
    ];

    /** === Year navigation === */
    prevYear() {
        this._year.update(y => y - 1);
        this.reloadYear();
    }

    nextYear() {
        this._year.update(y => y + 1);
        this.reloadYear();
    }

    constructor() {
    }

    async ngOnInit(): Promise<void> {
        // Lets retrieve a list of all employees (for the columns)
        this.isLoading.set(true);

        try {
            let response = await firstValueFrom(this._usersService.getAllUsers())
            // We need to prepare the employees list
            this._employees.set(response.users.map(u => ({
                key: '' + u.id,
                label: u.first_name[0] + '' + u.last_name[0],
                user: u
            })));
            console.log('Employees:', this._employees());
        } catch (e) {
            console.error(e);
        }

        await this.reloadYear();
    }

    // Dodaj tanko javno ovojnico
    public async refreshYear(): Promise<void> {
        // če želiš, lahko tu tudi upravljaš spinner
        this.isLoading.set(true);
        try {
            await this.reloadYear();
        } finally {
            this.isLoading.set(false);
        }
    }

    /** Re-fetch all marks for the newly selected year. */
    private async reloadYear(): Promise<void> {
        this.isLoading.set(true);
        try {
            const y = this._year();
            console.log('Reloading marks for year', y);
            // mark for check
            this._changeDetectorRef.markForCheck();

            // Helper: normalize any input to 'YYYY-MM-DD' without UTC shift surprises.
            const toYMD = (v: Date | string): string => {
                if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v; // already Y-M-D
                const d = v instanceof Date ? v : new Date(v);
                const yyyy = d.getFullYear();
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            };

            // Fetch recap data for the year
            // let respRecap = await firstValueFrom(this._absencesLeaveService.getVacationRecap(y))
            // this.recap = respRecap?.recap ?? [];
            // console.log('Recap data:', this.recap);

            /* 1) Fetch absences for the whole year (no pagination) */
            const resp = await firstValueFrom(
                this._absencesLeaveService.getUserAbsencePeriods(
                    /* user_id */ null,
                    /* page    */ 0,
                    /* size    */ 0,
                    /* sort    */ 'from_date',
                    /* order   */ 'asc',
                    /* search  */ this.searchInputControl.value ?? '',
                    /* filter  */ {year: y, use_pagination: false}
                )
            );
            const absences: Absence[] = resp?.absences ?? [];
            console.log('Absences:', absences);

            /* 2) Fetch holidays and prepare:
                  - holidayList (normalized)
                  - holidaySet: Set<YYYY-MM-DD> for day_free = 1
                  - holidayByDate: Map<YYYY-MM-DD, Holiday[]> (supports multiple holidays per day)
             */
            type Holiday = {
                id: number;
                date: string;             // normalized 'YYYY-MM-DD'
                title: string;
                description?: string | null;
                day_free?: 0 | 1;
                country_id?: number | null;
                // add other fields if you have them
            };

            let holidaySet: Set<string> | undefined;
            let holidayByDate: Map<string, Holiday[]> | undefined;

            try {
                if (this.countryIdForHolidays != null) {
                    const holidaysResp = await firstValueFrom(
                        this._holidaysService.getHolidays(
                            /* page   */ 0,
                            /* size   */ 0,
                            /* sort   */ 'date',
                            /* order  */ 'asc',
                            /* search */ '',
                            /* filter */ {
                                year: y,
                                use_pagination: 0
                                // country_id: this.countryIdForHolidays
                            }
                        )
                    );

                    const rawList: any[] = holidaysResp?.holidays ?? [];

                    console.log('Raw holidays:', rawList);

                    // Normalize and keep only items with a valid date
                    const holidayList: Holiday[] = rawList
                        .filter(h => !!h?.date)
                        .map(h => ({
                            ...h,
                            date: toYMD(h.date)
                        }));

                    // Build Set<date> for day_free === 1
                    holidaySet = new Set(
                        holidayList
                            .filter(h => Number(h.day_free) === 1)
                            .map(h => h.date)
                    );

                    // Group full holiday objects by date (can be multiple per date)
                    holidayByDate = new Map<string, Holiday[]>();
                    for (const h of holidayList) {
                        const arr = holidayByDate.get(h.date);
                        if (arr) arr.push(h);
                        else holidayByDate.set(h.date, [h]);
                    }

                    console.log('Holidays (normalized):', holidayList);
                    console.log('holidaySet:', holidaySet);
                    console.log('holidayByDate:', holidayByDate);
                }
            } catch (err) {
                console.warn('Holiday fetch failed; continuing without holidays.', err);
                holidaySet = undefined;
                holidayByDate = undefined;
            }

            /* 3) Employee keys */
            const employeesKeys = this._employees().map(e => e.key);

            /* 4) Build marks (holidays -> PR for all; absences overwrite per user/day)
                  Pass both holidaySet and holidayByDate so source can include full holiday object(s).
             */
            const marks = this.buildMarksFromAbsences(
                absences,
                y,
                employeesKeys,
                holidaySet,
                holidayByDate
            );

            console.log('Marks:', marks);

            /* 5) Push marks to the mini calendar */
            this._marks.set(marks);

        } catch (e) {
            console.error(e);
        } finally {
            this.isLoading.set(false);
        }
    }

    private readonly countryIdForHolidays: number | null = 705;

    /** Format Date -> 'YYYY-MM-DD' */
    private toISO(d: Date): string {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${dd}`;
    }

    private isWeekend(d: Date): boolean {
        const dow = d.getDay(); // 0=Sun, 6=Sat
        return dow === 0 || dow === 6;
    }

    /**
     * Build full marks list for the calendar:
     *  - Holidays: assign "PR" (public holiday) mark for ALL employees on those dates
     *  - Absences: expand date ranges day-by-day (skip weekends), map type -> cell value,
     *              and overwrite any "PR" mark for that specific employee/day.
     *
     *  Each resulting mark will also include a `.source` reference that points
     *  to the original data object (absence or holiday).
     */
    private buildMarksFromAbsences(
        absences: Absence[],
        year: number,
        employeesKeys: string[],
        /** dates to consider as holidays (normalized 'YYYY-MM-DD') */
        holidaySet?: Set<string>,
        /** full holiday objects grouped by date */
        holidayByDate?: Map<string, Holiday[]>      // <-- multiple holidays per date
    ): Mark[] {

        const marksMap = new Map<string, Mark>(); // key = `${YYYY-MM-DD}|${employeeKey}`

        /* 1) HOLIDAYS */
        if (holidaySet?.size) {
            for (const raw of holidaySet) {
                const iso = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(raw) ? raw : this.toISO(new Date(raw));
                const d = new Date(iso);
                if (isNaN(+d)) continue;
                if (this.isWeekend(d)) continue; // odstrani, če želiš prikaz tudi ob vikendih

                const holidaysArr = holidayByDate?.get(iso) ?? [{id: NaN, date: iso, title: 'Public Holiday'}];

                for (const empKey of employeesKeys) {
                    const k = `${iso}|${empKey}`;
                    marksMap.set(k, {
                        date: iso,
                        employeeKey: empKey,
                        value: 'PR',
                        kind: 'holiday',
                        source: {
                            kind: 'holiday',
                            items: holidaysArr,            // <-- array of holidays
                            item: holidaysArr[0]           // <-- optional convenience
                        }
                    });
                }
            }
        }

        /* 2) ABSENCES */
        const yearStart = new Date(year, 0, 1);
        const yearEnd = new Date(year, 11, 31);

        for (const a of absences) {
            const s0 = new Date(a.from_date);
            const e0 = new Date(a.to_date);
            if (isNaN(+s0) || isNaN(+e0)) continue;

            const s = s0 < yearStart ? yearStart : s0;
            const e = e0 > yearEnd ? yearEnd : e0;

            for (let d = new Date(s.getFullYear(), s.getMonth(), s.getDate());
                 d <= e;
                 d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)) {

                if (this.isWeekend(d)) continue;
                const iso = this.toISO(d);
                const empKey = String(a.user_id);

                const {value, kind, type} = this._utils.mapAbsenceTypeToCell(a.type);
                const k = `${iso}|${empKey}`;

                // overwrite holiday PR for that employee/day
                marksMap.set(k, {
                    date: iso,
                    employeeKey: empKey,
                    value, kind, type,
                    source: {
                        kind: 'absence',
                        items: [a],          // <-- always array
                        item: a              // <-- optional convenience
                    }
                });
            }
        }

        return Array.from(marksMap.values());
    }

    /**
     * On backdrop clicked
     */
    onBackdropClicked(): void {
        // Go back to the list
        this._router.navigate(['./'], {relativeTo: this._activatedRoute});

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    /** Fired when a day cell (leftmost column) is clicked. */
    onDay(d: Date) {
        // TODO: open detail modal / create entry for this date
        // console.log('dayClick', d);
    }

    /** Safe YYYY-MM-DD formatter in local time (no UTC shift). */
    toYMD(d: Date): string {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    }

    /** Fired when an employee cell is clicked. */
    onCell(e: MiniCalCellClickEvent) {
        console.log('cellClick', e);

        this.isLoading.set(true);

        try {
            // convenience: primary source (if any)
            const src = e.source ?? e.mark?.source ?? e.marks?.[0]?.source ?? null;

            // 1) EDIT existing absence
            if (src?.kind === 'absence' && src.item?.id) {
                const id = src.item.id as number;
                this._absencesLeaveService.absence = src.item as Absence; // optional: preload in service
                this._changeDetectorRef.markForCheck();
                this._router.navigateByUrl('/hr/leave-management/' + id);
                return;
            }

            // 2) HOLIDAY clicked — by default we don't edit holidays here.
            //    You can either show info, block creation, or allow creating absence over holiday.
            if (src?.kind === 'holiday') {
                // Example: allow creating absence over holiday → fall through to NEW.
                // Or: return after showing toast/dialog.
                // this._snack.open('Public holiday — creating absence is optional.', 'OK', { duration: 3000 });
            }

            // 3) NEW absence flow (no existing record on that day for this employee)
            //    Pass prefill via query params; backend/form can auto-apply defaults.
            const from = this.toYMD(e.date);
            const to = from;

            this._absencesLeaveService.absence = {
                id: 'new',
                user_id: Number(e.employeeKey),
                from_date: from,
                to_date: to,
                user: this.employees().find(u => u.key === e.employeeKey)?.user ?? null,
            }

            this._router.navigate(['/hr/leave-management/new'], {
                queryParams: {
                    // employeeId: e.employeeKey,
                    // from,
                    // to,
                }
            });
        } finally {
            this.isLoading.set(false);
            this._changeDetectorRef.detectChanges();
            this._changeDetectorRef.markForCheck();
        }

    }

    /**
     * Fired by each mini calendar when its visible month changes.
     * Use this if you plan to lazy-load marks month-by-month (optional).
     */
    async onMonth(e: { year: number; month: number; start: Date; end: Date }) {
        // Example lazy-loader:
        // this.isLoading.set(true);
        // const monthMarks = await this.myService.fetchMonthMarks(e.year, e.month);
        // this._marks.update(all => mergeOrReplace(all, monthMarks));
        // this.isLoading.set(false);
    }

    // If you prefer using (yearChange) instead of [(yearInput)]
    onYearChanged(y: number) {
        if (y !== this._year()) {
            this.isLoading.set(true);
            this._year.set(y);
            this.reloadYear();
        }
    }

    /** Header’s add button (hidden by default in your config). */
    onAddClicked() {
        // TODO: open “new vehicle/plan” form or similar
    }

    /** Optional: react to search changes (debounce in real usage) */
    private _watch = effect(() => {
        const query = this.searchInputControl.value?.trim() ?? '';
        void query; // use if you want live filtering/fetch
    });
}
